import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ALL_SETUP_WIZARD_STEPS, Client, SetupWizardPayload, SetupWizardState } from '@mira-avant/mtlibs';
import { NavigationService } from '../../../../../services/navigation.service';
import { SetupWizard } from '../../../../../services/setup-wizard';
import { SetupWizardDashboard } from '../setup-wizard-dashboard/setup-wizard-dashboard';
import { SetupWizardViewPreviousJobs } from '../setup-wizard-view-previous-jobs/setup-wizard-view-previous-jobs';
import { SetupWizardViewPreviousJobDetails } from '../setup-wizard-view-previous-job-details/setup-wizard-view-previous-job-details';
import { SetupWizardUploadCsvs } from '../setup-wizard-upload-csvs/setup-wizard-upload-csvs';
import { SetupWizardEditSteps } from '../setup-wizard-edit-steps/setup-wizard-edit-steps';
import { SetupWizardPreviewJob } from '../setup-wizard-preview-job/setup-wizard-preview-job';
import { SetupWizardFinished } from '../setup-wizard-finished/setup-wizard-finished';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
	selector: 'app-setup-wizard-editor',
	standalone: true,
	imports: [
		CommonModule,
		SetupWizardDashboard,
		SetupWizardViewPreviousJobs,
		SetupWizardViewPreviousJobDetails,
		SetupWizardUploadCsvs,
		SetupWizardEditSteps,
		SetupWizardPreviewJob,
		SetupWizardFinished,
		NzSpinModule,
	],
	templateUrl: './setup-wizard-editor.html',
	styleUrl: './setup-wizard-editor.scss',
})
export class SetupWizardEditor {
	readonly state$: Observable<SetupWizardState>;
	readonly SetupWizardState = SetupWizardState;
	private clientUuid: string | undefined;

	constructor(
		private route: ActivatedRoute,
		private nav: NavigationService,
		private setupWizard: SetupWizard
	) {
		this.state$ = this.route.paramMap.pipe(
			map(params => {
				const state = params.get('state') as SetupWizardState | null;
				const newClientUuid = params.get('clientUuid') || undefined;

				if (state && !Object.values(SetupWizardState).includes(state)) {
					throw new Error(`Invalid SetupWizardState: ${state}`);
				}

				if (this.clientUuid !== newClientUuid) {
					//If we see a new clientUuid come in then load the preview for it
					this.setupWizard.loadClientPayload$(ALL_SETUP_WIZARD_STEPS, newClientUuid);

					this.clientUuid = newClientUuid;
				}

				return state as SetupWizardState;
			})
		);
	}

	async onSelectClient(client: Client) {
		this.nav.navigate(['my', 'admin', 'setup-wizard', SetupWizardState.DASHBOARD, client.uuid]);
	}

	async onApplyToPreview(payload: SetupWizardPayload) {
		const currentPreview = this.setupWizard.preview$.getValue();
		console.log('TODO: Merge', payload, 'into', currentPreview);
	}
}
